import { render, staticRenderFns } from "./BandwidthUsage.vue?vue&type=template&id=7671eda6&"
import script from "./BandwidthUsage.vue?vue&type=script&lang=js&"
export * from "./BandwidthUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports